// Los botones deben estar a lado de las sections a esconder,
// sino se romperá el script ya que depende del "nextElementSibling"
// para funcionar

const buttons = document.querySelectorAll(".toggle-section-button");
buttons.forEach((btn) => {
  const parentClassnames = btn.parentElement.classList;
  btn.addEventListener("click", (e) => {
    if (e.target.innerText === "Hide") {
      e.target.textContent = "Show";
    } else {
      e.target.textContent = "Hide";
    }
    const media = window.matchMedia("(max-width: 768px)");
    e.target.classList.toggle("inverted-hide-btn")
    if (parentClassnames.contains("faq-title")) {
      const section = e.target.parentElement.parentElement.nextElementSibling;
      section.classList.toggle("acro-hidden");
    } else if (parentClassnames.contains("how-to-title")) {
      const section = e.target.parentElement.nextElementSibling.nextElementSibling;
      section.classList.toggle("acro-special-hidden");
    } else if (parentClassnames.contains("nutri-title")) {
      const section = e.target.parentElement.nextElementSibling;
      section.classList.toggle("acro-special-hidden");
    } else if (parentClassnames.contains("benefit-title") && media.matches ) {
      const section = e.target.parentElement.nextElementSibling.nextElementSibling;
      section.classList.toggle("acro-hidden");
    } else {
      const section = e.target.parentElement.nextElementSibling;
      section.classList.toggle("acro-hidden");
    }
  });
});

// Carousels de Flickity
function renderCarousel() {
  const media = window.matchMedia("(max-width: 768px)");
  let groupCells;
  let pageDots;

  if (media.matches) {
    pageDots = true;
    groupCells = 1;
  } else {
    groupCells = 2;
    pageDots = false;
  }

  var flkty = new Flickity(".specialist-carousel", {
    pageDots,
    contain: true,
    groupCells,
    wrapAround: false
    });

  var flkty = new Flickity(".main-carousel", {
    pageDots,
    groupCells,
    wrapAround: false,
    contain: true
    });
}

window.addEventListener("load", (e) => {
  renderCarousel();
});

window.addEventListener("resize", (e) => {
  renderCarousel();
});

console.log("Acromatico Script loaded");
